function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import { cmsActions } from '../../reducers/cms.reducer';
import ModalHeader from '../modal/ModalHeader.react';
import Input from '../common/form/Input.react';
import Label from '../common/form/Label.react';
import Button from '../common/Button.react';
import Select from '../common/form/Select.react';
var NavigationAdd = function NavigationAdd(_ref) {
  var _ref$app = _ref.app,
    app = _ref$app === void 0 ? '' : _ref$app,
    _ref$navBarArr = _ref.navBarArr,
    navBarArr = _ref$navBarArr === void 0 ? [] : _ref$navBarArr,
    hideModalAction = _ref.hideModalAction,
    navigationAction = _ref.navigationAction;
  var items = useSelector(function (s) {
    return s.cms.navigation || {};
  });
  var _useState = useState({
      title: '',
      parentID: null,
      navbar: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var title = state.title,
    parentID = state.parentID,
    navbar = state.navbar;
  useEffect(function () {
    $('#navigation-add-input').focus();
    if (navBarArr.length === 1) setState(_objectSpread(_objectSpread({}, state), {}, {
      navbar: navBarArr[0]
    }));
  }, []);
  var isValid = function isValid() {
    return app.length > 0 && navbar.length > 0 && title.length > 0;
  };
  var dict = {
    'header': 'Desktop Header',
    'header-top': 'Desktop Header Top Row',
    'header-bottom': 'Desktop Header Bottom Row',
    'footer': 'Desktop Footer',
    'mobile-menu': 'Mobile Menu'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Add Navigation Item"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body"
  }, /*#__PURE__*/React.createElement(Label, {
    label: "Nav Bar Type",
    required: true
  }), /*#__PURE__*/React.createElement(Select, {
    value: navbar,
    options: navBarArr.map(function (x) {
      return {
        sLabel: dict[x],
        sValue: x
      };
    }),
    onChange: function onChange(_ref2) {
      var sValue = _ref2.sValue;
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        navbar: sValue
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Title",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: title,
    id: "navigation-add",
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        title: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Parent Tab"
  }), /*#__PURE__*/React.createElement(Select, {
    value: parentID,
    options: Object.values(items).filter(function (x) {
      return x.clientApp === app;
    }).filter(function (x) {
      return x.navbar === navbar;
    }).filter(function (x) {
      return x.children;
    }).sort(function (a, b) {
      return a.title.localeCompare(b.title);
    }).map(function (x) {
      return {
        sLabel: x.title,
        sValue: x._id
      };
    }),
    onChange: function onChange(_ref3) {
      var sValue = _ref3.sValue;
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        parentID: sValue
      }));
    }
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      navigationAction({
        formData: {
          app: app,
          navbar: navbar,
          title: title,
          parentID: parentID
        },
        method: 'post'
      });
      hideModalAction();
    },
    label: "Add",
    disabled: !isValid()
  })));
};
var mdtp = {
  articlesAction: cmsActions.articles,
  navigationAction: cmsActions.navigation,
  hideModalAction: modalActions.hide
};
export default connect(null, mdtp)(NavigationAdd);